export const ACCOUNT_LINKING = '/account-linking';
export const ACCOUNT_MANAGEMENT = '/acctmgmt';
export const AUTH_MANAGEMENT = '/auth';
export const ADMIN = '/admin';
export const BUG_REPORT = '/bugs';
export const CHAT = '/chat';
export const CODEX = '/codex';
export const COMBAT = '/combat';
export const CORPORATION = '/corporation';
export const COMBAT_LOGS = '/combatlogs';
export const DISCORD_INVITE = 'https://discord.betweenworlds.net';
export const EDITOR = '/editor';
export const EQUIPMENT = '/equipment';
export const EXPLORE = '/explore';
export const ITEMS = '/items';
export const LANDING = '/';
export const LEADERBOARDS = '/leaderboards';
export const LOGIN = '/login';
export const LOGOUT = '/logout';
export const MAIL = '/mail';
export const MISSIONS = '/missions';
export const MODERATOR = '/moderator';
export const NEWS = '/news';
export const NOTIFICATIONS = '/notifications';
export const PARTY = '/party';
export const PATREON = 'https://www.patreon.com/athano';
export const PRIVACY = '/privacy';
export const PROFILE = '/profile';
export const RECOVER_PASS = '/recoverpass';
export const REGISTER = '/register';
export const ROADMAP = '/roadmap';
export const RULES = '/rules';
export const SCREENSHOTS = '/screenshots';
export const SEARCH = '/search';
export const SETTINGS = '/settings';
export const SKILLS = '/skills';
export const TRAITS = '/traits';
export const STATISTICS = '/statistics';
export const TWITCH = 'https://twitch.tv/athano';
export const UPDATE_LOG = '/updatelog';
export const USER = '/user';

// Paths that can only be accessed while logged in:
export const PRIVATE_PATHS = [
  ACCOUNT_MANAGEMENT,
  ADMIN,
  CHAT,
  CODEX,
  COMBAT_LOGS,
  COMBAT,
  EDITOR,
  EQUIPMENT,
  ITEMS,
  LANDING,
  LEADERBOARDS,
  LOGOUT,
  MAIL,
  MISSIONS,
  MODERATOR,
  NOTIFICATIONS,
  PARTY,
  PROFILE,
  ROADMAP,
  RULES,
  SEARCH,
  SETTINGS,
  SKILLS,
  TRAITS,
  UPDATE_LOG,
  USER,
];
